import React from 'react';
import PropTypes from 'prop-types';
import OfficePageCitiesListItem from './OfficePageCitiesListItem';
import Styles from './OfficePageCitiesList.scss';

const OfficePageCitiesList = ({ activeCity, setActiveCity, cities }) => (
  <div className={Styles.list}>
    {cities.map((city) => (
      <OfficePageCitiesListItem
        key={city}
        isActive={city === activeCity}
        setActiveItem={() => setActiveCity(city)}
      >
        {city}
      </OfficePageCitiesListItem>
    ))}
  </div>
);

OfficePageCitiesList.propTypes = {
  activeCity: PropTypes.string,
  setActiveCity: PropTypes.func,
  cities: PropTypes.array,
};

export default OfficePageCitiesList;
